type informationProps = {
  privacyPolicy: string
  terms: string
  serviceUse?: string
  phone: string
  email: string
  requestForm: string
  manual?: string
}

export const med: informationProps = {
  privacyPolicy: 'https://www.integrity-healthcare.co.jp/privacypolicy',
  terms: 'https://support.yadoc.jp/terms/quick/',
  serviceUse: 'https://www.yadoc.jp/notice20230705',
  phone: '0570-05-1114',
  email: 'ds@yadoc.jp',
  requestForm: 'https://support.yadoc.jp/contact/medical/inquiry-support/',
  manual: 'https://www.yadoc.jp/quick/support/manual',
}

export const personal: informationProps = {
  privacyPolicy: 'https://www.integrity-healthcare.co.jp/privacypolicy',
  terms: 'https://support.yadoc.jp/terms/quick/personal/',
  phone: '0120-22-8109',
  email: 'ps@yadoc.jp',
  requestForm: 'https://support.yadoc.jp/contact/personal/inquiry-personal/ ',
}

const information: {
  [name: string]: informationProps
} = {
  med,
  personal,
}

export default information
